require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/number/is-integer.js
// module id = 231
// module chunks = 0